const getters = {
    accessToken: state => state.common.accessToken,
    coupons: state => state.common.coupons,
    loanAmount: state => state.common.loanAmount,
    loanDays: state => state.common.loanDays,
    bankData: state => state.common.bankData,
    isRepeatLoan: state => state.common.isRepeatLoan,
};
export default getters
